import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PChipRadioGroupComponent } from '@panaya/ui/p-chip-radio-group';
import { PFieldTextModule, TextAreaEnum } from '@panaya/ui/p-field-text';
import { PActionButtonModule } from '@panaya/ui/p-action-button';
import { FeedbackMode } from '@panaya/ui/p-like-dislike';
import { Reason, ReasonItem, REASONS, UserFeedback } from '@panaya/ai-chat/shared';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    standalone: true,
    selector: 'user-feedback-interaction',
    imports: [PFieldTextModule, PChipRadioGroupComponent, NgIf, PActionButtonModule, FormsModule, TranslateModule],
    templateUrl: './ai-chat-user-feedback-interaction.component.html',
    styleUrls: ['./ai-chat-user-feedback-interaction.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiChatUserFeedbackInteractionComponent {
    @Output() public readonly selectedReasonChanged = new EventEmitter<UserFeedback>();
    @Output() public readonly textSubmitted = new EventEmitter<UserFeedback>();

    protected readonly inputSize = TextAreaEnum.FullWidth;
    protected translatedReasons: ReasonItem[] = [];
    protected feedbackText = '';
    private readonly reasons = REASONS;

    constructor(private readonly translateService: TranslateService) {
        this.translatedReasons = this.reasons.map(({ id, label }) => ({
            id,
            label: this.translateService.instant(label)
        }));
    }

    private _selectedReason: Reason | undefined = undefined;

    protected set selectedReason(value: Reason | undefined) {
        this._selectedReason = value;
        this.selectedReasonChanged.emit(this.userFeedback);
    }

    protected get selectedReason(): Reason | undefined {
        return this._selectedReason;
    }

    protected submitButtonClicked(): void {
        this.textSubmitted.emit(this.userFeedback);
    }

    private get userFeedback(): UserFeedback {
        return {
            mode: FeedbackMode.DISLIKE,
            reason: this.selectedReason,
            text: this.feedbackText
        };
    }
}
